import { Button, Card, CardContent, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

export const CarePlanPrompt = () => {
    return (
        <Card
            elevation={0}
            sx={{
                mt: 2,
                mb: 2,
                border: 1,
                borderColor: 'divider',
                backgroundColor: '#FFF'
            }}
        >
            <CardContent sx={{ px: 4 }}>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                >
                    Once your provider reviews your results, they will update
                    your Care Plan. For next steps:
                </Typography>

                <Button
                    component={Link}
                    to="/your-care/plan"
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{
                        borderColor: 'primary.light',
                        textTransform: 'none',
                        fontWeight: 'bold'
                    }}
                >
                    Check out your Care Plan
                </Button>
            </CardContent>
        </Card>
    )
}
